import { Loader2 } from "lucide-react";

function getLoadingText(): string {
  const lang = localStorage.getItem("preferred-language");
  return lang === "en" ? "Loading..." : "იტვირთება...";
}

export function ModalLoadingFallback() {
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-background/80 backdrop-blur-sm">
      <div className="flex items-center gap-2 text-muted-foreground">
        <Loader2 className="h-5 w-5 animate-spin" />
        <span className="text-sm">{getLoadingText()}</span>
      </div>
    </div>
  );
}
